import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'

import HomePage from './pages/HomePage'
import TripsPage from './pages/TripsPage'
import TripDetailPage from './pages/TripDetailPage'
import DestinationsPage from './pages/DestinationsPage'
import DestinationDetailPage from './pages/DestinationDetailPage'
import HotelsPage from './pages/HotelsPage'
import HotelDetailPage from './pages/HotelDetailPage'
import TravelTypesPage from './pages/TravelTypesPage'
import GalleryPage from './pages/GalleryPage'
import AboutPage from './pages/AboutPage'
import ConceptPage from './pages/ConceptPage'
import ProcessPage from './pages/ProcessPage'
import PracticalInfoPage from './pages/PracticalInfoPage'
import ContactPage from './pages/ContactPage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-slate-950 text-slate-100 font-sans selection:bg-cyan-500 selection:text-slate-950">
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/skirejser" element={<TripsPage />} />
          <Route path="/skirejser/:slug" element={<TripDetailPage />} />
          <Route path="/destinationer" element={<DestinationsPage />} />
          <Route path="/destinationer/:slug" element={<DestinationDetailPage />} />
          <Route path="/hoteller" element={<HotelsPage />} />
          <Route path="/hoteller/:slug" element={<HotelDetailPage />} />
          <Route path="/rejsetyper" element={<TravelTypesPage />} />
          <Route path="/galleri" element={<GalleryPage />} />
          <Route path="/om-os" element={<AboutPage />} />
          <Route path="/konceptet" element={<ConceptPage />} />
          <Route path="/processen" element={<ProcessPage />} />
          <Route path="/praktisk-information" element={<PracticalInfoPage />} />
          <Route path="/betingelser" element={<PracticalInfoPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App
